<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Aksiyon Adı</label>
            <v-select-list :options="actionNames" label="Name" v-model="actionName" placeholder="Aksiyon Adı"></v-select-list>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">İşlem Seviyesi</label>
            <v-select-list :options="actionLogLevels" label="Name" v-model="actionLogLevel" placeholder="İşlem Seviyesi"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filter)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import LogOperationsApi from '@/api/log-operations'
export default {
    data(){
        return{
            actionNames:[],
            actionLogLevels:[],
            filter:{
                ActionLogLevel:null,
                ActionName:null,
            }
        }
    },
    mounted(){
        this.getActionLogLevels()
        this.getActionNames()
    },
    methods:{
        clearForm(){
            this.dateRange = null
            this.filter.ActionLogLevel = null
            this.filter.ActionName = null
            this.$emit('filter',this.filter)
        },
        getActionLogLevels(){
            LogOperationsApi.GetActionLogLevels().then(res=>{
                this.actionLogLevels = res.data.Data
            })
        },
        getActionNames(){
            LogOperationsApi.GetActionNames().then(res=>{
                this.actionNames = res.data.Data
            })
        }
    },
    computed:{
        actionLogLevel:{
            get:function(){
                return this.actionLogLevels.find(s=>s.Value==this.filter.ActionLogLevel)
            },
            set:function(value){
                this.filter.ActionLogLevel = value?.Value == 0 ? 0 : value?.Value ||  null
            }
        },
        actionName:{
            get:function(){
                return this.actionNames.find(s=>s.Value==this.filter.ActionName)
            },
            set:function(value){
                this.filter.ActionName = value?.Value == 0 ? 0 : value?.Value ||  null
            }
        }
    }
}
</script>